import React, { FunctionComponent as FC } from 'react';
import './index.scss';
import { Link } from 'react-router-dom';
import SectionTitle from '../SectionTitle';

interface MyPanelProps {
  viewTitle: string;
  width: string;
  height: string;
  panelHeaderHeight: number;
  className?: string;
  // x?: number;
  // y?: number;
  children: React.ReactNode; // 👈️ added type for children
}

// const panelStyle = {
//   // titleDivWidth:
// }

const MyPanel: FC<MyPanelProps> = (props) => {

  const {
    viewTitle,
    width,
    height,
    panelHeaderHeight,
    className,
  } = props

  if (viewTitle === '') {
    return (
      <div className={`panel${className ? ` ${className}` : ''}`} data-section={viewTitle || undefined} style={{width: width, height: height}}>
        <div className='panel-header' style={{minHeight: panelHeaderHeight}}>
          <div className='left-align'>
            {/* <SectionTitle title={viewTitle} /> */}
          </div>
        </div>
        <div className='panel-body'>
          {props.children}
        </div>
      </div>
    )
  }
  if (viewTitle === 'DATA-DRIVEN ART') {
    return (
      <div className={`panel${className ? ` ${className}` : ''}`} data-section={viewTitle || undefined} style={{width: width, height: height}}>
        <div className='panel-header data-art-title' style={{minHeight: panelHeaderHeight, justifyContent: 'space-between'}}>
          <div className='left-align'>
            <SectionTitle title={viewTitle} />
          </div>
          <div className='read-more'>
            <Link to="/dataArtPage">
              <span>READ MORE ▶</span>
            </Link>
            {/* <Link to="/dataArtPage" onClick={(e) => {
              e.preventDefault();
              window.location.href = '/dataArtPage';
            }}>
              <span>READ MORE ▶</span>
            </Link> */}
          </div>
        </div>
        <div className='panel-body'>
          {props.children}
        </div>
      </div>
    )
  }
  return (
    <div className={`panel${className ? ` ${className}` : ''}`} data-section={viewTitle || undefined} style={{width: width, height: height}}>
      <div className='panel-header' style={{minHeight: panelHeaderHeight}}>
        <div className='left-align'>
          {/* <span className="panel-title">{viewTitle}</span> */}
          {/* <span className="dot">.</span> */}
          <SectionTitle title={viewTitle} />
        </div>
        {/* <div className='line'></div> */}
      </div>
      <div className='panel-body'>
      {/* style={{height: height - panelHeaderHeight}} */}
        {props.children}
      </div>
    </div>
  )
}

export default MyPanel